module.exports = __webpack_public_path__ + "top_page/industry-medical-0736b6fa1eb4018d392270eb7abfe937.svg";